// extracted by mini-css-extract-plugin
export default {"outer":"FAQ_outer__-X2au","header":"FAQ_header__2Zspc","question":"FAQ_question__BvO5b","icon":"FAQ_icon__0SRya","answer":"FAQ_answer__I4dVv"};